module.exports = __webpack_public_path__ + "static/media/fa-search.1c562c9c.png";